import type { RootState } from "@src/store/rootState";
import { getAgProducts } from "@src/store/slices/agProducts";
import { selectedActivatedModArray } from "@src/store/slices/experienceInfoState";
import {
  getExperienceProducts,
  getStoredExperienceProducts,
} from "@src/store/slices/experienceProducts";
import { selectedExperience } from "@src/store/slices/experiences";
import { getOfferProducts } from "@src/store/slices/offerProducts";

export const getProductType = (state: RootState) => {
  const experience = selectedExperience(state);
  if (experience?.category === "experiment") {
    if (experience.type === "pricing") {
      return "price";
    }
    if (experience.type?.includes("content")) {
      return "analytics";
    }
    if (experience.type === "personalization/offer") {
      return "offer";
    }
    return undefined;
  } else {
    const activatedMods = selectedActivatedModArray(state) ?? [];
    const experienceProducts = getExperienceProducts(state) ?? [];
    const storedExperienceProducts = getStoredExperienceProducts(state) ?? [];
    const agProducts = getAgProducts(state) ?? [];
    const offerProducts = getOfferProducts(state) ?? [];
    if (
      (activatedMods.includes("price") && agProducts.length > 0) ||
      (storedExperienceProducts.length > 0 && experienceProducts.length === 0)
    ) {
      return "price";
    }
    if (offerProducts && offerProducts.length > 0) {
      return "offer";
    }
    return undefined;
  }
};
